import { FronteggContext } from '@frontegg/rest-api';
import { Axios } from 'src/lib';
import { showToastError } from 'src/utilities/errortoast';
import { showToastSuccess } from 'src/utilities/toast';
import {
  createConditionConfig,
  deleteConditionConfig,
  editConditionConfig,
  filterConditionsConfig,
  getAllConditionsConfig,
  getConditionByIdConfig,
} from '../lib/condition.url';
import {
  getAllConditionsListLoadingSlice,
  getAllConditionsListSlice,
  getAllSpecialtiesListSlice,
} from '../slices';
import {
  getConditionByIdSlice,
  getConditionsDropdownSlice,
  superAdminLoadingSlice,
} from '../slices/condition.slice';

export const getAllConditionListAction = () => {
  return async (dispatch) => {
    try {
      dispatch(getAllConditionsListLoadingSlice(true));
      const { url } = getAllConditionsConfig();
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Headless-Mode': true,
      };
      const result = await Axios.get(url, { headers });
      const response = result?.data?.conditions;
      if (result?.status === 200 && response) {
        dispatch(getAllConditionsListSlice(response));
        dispatch(getConditionsDropdownSlice(response));
      }
    } catch (e) {
      dispatch(superAdminLoadingSlice(false));
      showToastError('Error occurred');
    } finally {
      dispatch(getAllConditionsListLoadingSlice(false));
    }
  };
};

export const getConditionListAction = () => {
  return async (dispatch) => {
    dispatch(superAdminLoadingSlice(true));
    try {
      const { url } = getAllConditionsConfig();
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Headless-Mode': true,
      };
      const result = await Axios.get(url, { headers });
      const response = result?.data?.conditions;
      if (result?.status === 200 && response) {
        dispatch(superAdminLoadingSlice(false));
        dispatch(getAllConditionsListSlice(response));
        dispatch(getConditionsDropdownSlice(response));
      }
    } catch (e) {
      dispatch(superAdminLoadingSlice(false));
      showToastError('Error occurred');
    }
  };
};

export const addNewCondition = (
  payload,
  setIsOpen,
  setRadioButtonvalue,
  isfilterOn,
  filterValue
) => {
  return async (dispatch) => {
    dispatch(superAdminLoadingSlice(true));
    try {
      const { url } = createConditionConfig();
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Headless-Mode': true,
      };
      const result = await Axios.post(url, payload, { headers });
      if (result?.status === 200) {
        dispatch(superAdminLoadingSlice(false));
        showToastSuccess('Condition created successfully');
        setIsOpen(false);
        dispatch(getAllSpecialtiesListSlice(null));
        isfilterOn
          ? dispatch(
              filterConditionsApi(
                filterValue?.specialty_id,
                filterValue?.condition_id
              )
            )
          : dispatch(getAllConditionListAction());
        setRadioButtonvalue(1);
      }
    } catch (e) {
      dispatch(superAdminLoadingSlice(false));
      showToastError('Error occurred');
    }
  };
};

export const getConditionByIdAction = (condition_id, setEditModalOpen) => {
  return async (dispatch) => {
    dispatch(superAdminLoadingSlice(true));
    try {
      const { url } = getConditionByIdConfig(condition_id);
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Headless-Mode': true,
      };
      const result = await Axios.get(url, { headers });
      const response = result?.data;
      if (result?.status === 200 && response) {
        dispatch(getConditionByIdSlice(response));
        setEditModalOpen(true);
        dispatch(superAdminLoadingSlice(false));
      }
    } catch (e) {
      dispatch(superAdminLoadingSlice(false));
      showToastError('Error occurred');
    }
  };
};

export const editConditionByIdAction = (
  condition_id,
  payload,
  setIsOpen,
  isfilterOn,
  filterValue
) => {
  return async (dispatch) => {
    dispatch(superAdminLoadingSlice(true));
    try {
      const { url } = editConditionConfig(condition_id);
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Headless-Mode': true,
      };
      const result = await Axios.put(url, payload, { headers });
      if (result?.status === 200) {
        setIsOpen(false);
        dispatch(superAdminLoadingSlice(false));
        showToastSuccess('Condition edited successfully');
        isfilterOn
          ? dispatch(
              filterConditionsApi(
                filterValue?.specialty_id,
                filterValue?.condition_id
              )
            )
          : dispatch(getAllConditionListAction());
      }
    } catch (e) {
      dispatch(superAdminLoadingSlice(false));
      showToastError('Error occurred');
    }
  };
};

export const deleteConditionByIdAction = (
  condition_id,
  setIsOpen,
  isfilterOn,
  filterValue
) => {
  return async (dispatch) => {
    dispatch(superAdminLoadingSlice(true));
    try {
      const { url } = deleteConditionConfig(condition_id);
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Headless-Mode': true,
      };
      const result = await Axios.delete(url, { headers });
      if (result?.status === 200) {
        dispatch(superAdminLoadingSlice(false));
        showToastSuccess('Condition deleted successfully');
        setIsOpen(false);
        isfilterOn
          ? dispatch(
              filterConditionsApi(
                filterValue?.specialty_id,
                filterValue?.condition_id
              )
            )
          : dispatch(getAllConditionListAction());
      }
    } catch (e) {
      dispatch(superAdminLoadingSlice(false));
      showToastError('Error occurred');
    }
  };
};

export const filterConditionsApi = (specialty_id, condition_id) => {
  return async (dispatch) => {
    dispatch(superAdminLoadingSlice(true));
    try {
      const { url } = filterConditionsConfig();
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Headless-Mode': true,
      };
      const payload = {
        specialty_id: specialty_id,
        condition_id: condition_id,
      };
      const result = await Axios.post(url, payload, { headers });
      const response = result?.data;
      if (result?.status === 200 && response) {
        dispatch(getAllConditionsListSlice(response));
        dispatch(superAdminLoadingSlice(false));
      }
    } catch (e) {
      dispatch(superAdminLoadingSlice(false));
      showToastError('Error occurred');
    }
  };
};
